import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/internal/Observable";
import { PdfResponse } from "../models/pdfResponse";
import { map } from "rxjs";


@Injectable({
    providedIn: "root"
})
export class PdfGenerationService {
    private createHeader(isForBlob = false): any {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        };

        if (isForBlob) {
            (httpOptions as any).responseType = 'blob';
            (httpOptions as any).observe = 'response';
        }
        return httpOptions;
    }

    constructor(private httpClient: HttpClient) { }
    
    generatePlanPdf(planId: string, isSimplified: boolean): Observable<PdfResponse> {
        return this.httpClient.post(`${environment.ApiEndpoint}/Pdf/GeneratePlanPdf?planId=${planId}&isSimplified=${isSimplified}`, null, this.createHeader(true))
            .pipe(map((response: any) => {
                const contentDisposition = response.headers.get("Content-Disposition");

                let filename = "";
                if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
                    const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const matches = fileNameRegex.exec(contentDisposition);
                    if (matches != null && matches[1]) { 
                        filename = matches[1].replace(/['"]/g, '');
                    }
                }

                const data: PdfResponse = { data: response.body, fileName: filename };
                return data;
            }));
    }

    emailPlanPdf(planId: string, isSimplified?: boolean): Observable<any> {
        let url = `${environment.ApiEndpoint}/Pdf/EmailPlanPdf?planId=${planId}`;
        if (isSimplified != undefined) {
            url += `&isSimplified=${isSimplified}`
        }

        return this.httpClient.post(url, null, this.createHeader());
    }
}